import { createStandaloneToast } from '@chakra-ui/react';

// Casting to 'any' to avoid inferred type portability issue
export const { ToastContainer, toast } = createStandaloneToast() as any;
